import { render, staticRenderFns } from "./MeasurementRow.vue?vue&type=template&id=cc6c8e36&"
import script from "./MeasurementRow.vue?vue&type=script&lang=js&"
export * from "./MeasurementRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports